import 'hammerjs';
import {
  enableProdMode,
  TRANSLATIONS,
  TRANSLATIONS_FORMAT
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CompilerOptions } from '@angular/core/src/linker/compiler';
import { BootstrapOptions } from '@angular/core/src/application_ref';

if (environment.production) {
  enableProdMode();
}

// use the require method provided by webpack
declare const require;
// we use the webpack raw-loader to return the content as a string
const translations = require(`raw-loader!./locale/messages.ru.xlf`);

platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [
    { provide: TRANSLATIONS, useValue: translations },
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' }
  ]
} as (CompilerOptions & BootstrapOptions)).catch(err => console.error(err));
